"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utilityRehydratableName = require("@emcm-ui/utility-rehydratable-name");

var _utilityRehydratableName2 = _interopRequireDefault(_utilityRehydratableName);

var _AjaxContentContainer = require("../AjaxContentContainer/AjaxContentContainer");

var _AjaxContent = require("../../AjaxContent.js");

var _AjaxContent2 = _interopRequireDefault(_AjaxContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AjaxContentWithContext = function AjaxContentWithContext(props) {
  return _react2.default.createElement(
    _AjaxContentContainer.AjaxContentContext.Consumer,
    null,
    function (ajaxContext) {
      return _react2.default.createElement(
        "div",
        { "data-rehydratable": (0, _utilityRehydratableName2.default)(_AjaxContent2.default.displayName) },
        _react2.default.createElement(
          _AjaxContent2.default,
          _extends({}, props, {
            location: ajaxContext && ajaxContext.href !== "" ? ajaxContext.href : props.location
          }),
          props.children
        )
      );
    }
  );
};

AjaxContentWithContext.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  location: _propTypes2.default.string
};

exports.default = AjaxContentWithContext;